<!-- 账号密码登录 -->
<template>
	<div class="login_warp">
		<img src="@/assets/images/login/login_bg.png" alt="" />
		<div class="login_mask"></div>
		<div class="login">
			<div class="logo_warp flex flex-x-center flex-y-end">
				<div class="logo">
					<img src="@/assets/images/logobk.png" alt="" />
				</div>
			</div>

			<div class="login_form_wrap m-top30 flex flex-column flex-y-center">
				<div class="col-fff fontSize50 fontWeight" style="letter-spacing: 3px">
					迪信达物流管理系统
				</div>
				<div class="login_from_warp m-top20 flex flex-column flex-y-center">
					<img src="@/assets/images/login/login_form.png" alt="" />

					<div class="login_from">
						<div class="login_type_warp flex flex-x-end flex-y-start">
						</div>
						<form v-if="loginType == 1">
							<div class="login_input_warp flex flex-y-center">
								<img src="@/assets/images/login/zhanghao.png" alt="" srcset="" />
								<div class="login_input_line"></div>
								<div class="flex-1 m-left20 m-right20">
									<input type="text" placeholder="请输入登录账号" v-model="dxduserName" class="fontSize16" />
								</div>
							</div>
							<div class="login_input_warp flex flex-y-center">
								<img src="@/assets/images/login/suo.png" alt="" srcset="" />
								<div class="login_input_line"></div>
								<div class="flex-1 m-left20 m-right20">
									<input type="password" placeholder="请输入登录密码" v-model="dxduserPwd" class="fontSize16"
										autocomplete="off" />
								</div>
							</div>
							<div class="login_input_warp flex flex-y-center default_bg">
								<verify></verify>
							</div>
							<div class="login_input_warp flex flex-y-center default_bg flex-x-center fontSize16 pointer col-fff"
								@click="toLogin()">
								登录
							</div>
						</form>

						<div class="login_from_bottom flex flex-x-between">
							<div class="m-left5 flex flex-y-center" v-if="loginType == 1">
								<el-checkbox style="transform: calc(1.5)" v-model="isChecked"
									@change="changeChecked(isChecked)"></el-checkbox><span
									class="col-fff fontSize14 m-left10">记住密码</span>
							</div>
							<div v-if="loginType == 2"></div>
							<!--  <div class="col-fff fontSize14 m-right5 pointer">
                货源方入驻 》
              </div> -->
						</div>
					</div>
				</div>

				<div class="inner downWrap">
					<div class="downBox flex flex-column flex-y-center">
						<div class="downBoxLeft flex flex-column flex-y-center">
							<img class="erweima" src="@/assets/images/erweima.png" alt="" />
							<p>扫码下载APP</p>
						</div>
						<div >
							<p style="font-size: 25px;color: #0dbc53;line-height: 100px;  margin-bottom: 20px;font-weight: 600;  letter-spacing: 5px;">
								<!-- 点击下载APP -->
							</p>
							<div class="flex flex-y-center">
								<div class="hover_box hover_box_apple flex flex-y-center downItem"
									@click.stop="upLoad()">
									<span>司机端下载</span>
								</div>
								<!-- <div class="hover_box hover_box_anzhuo flex flex-y-center downItem"
									@click.stop="upLoad('rpt')">
									<span>管理端下载</span>
								</div> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		defineComponent,
		nextTick,
		onMounted,
		reactive,
		toRefs,
		getCurrentInstance,
	} from "vue";
	import "@/assets/js/wxLogin.js";
	import wxLogin from "./wxLogin.vue";
	import QRCode from "qrcodejs2";
	import {
		setToken,
		getToken
	} from "@/libs/tools";
	import $ from "jquery";
	import verify from "./loginVerify";
	import {
		useStore
	} from "vuex";
	import {
		useRouter
	} from "vue-router";
	export default defineComponent({
		name: "login",
		components: {
			verify: verify,
		},
		setup() {
			const {
				proxy
			} = getCurrentInstance();
			const store = useStore();
			const router = useRouter();
			// 数据
			const data = reactive({
				loginType: 1,
				// dxduserName: "admin",
				// dxduserPwd: "fg123456",
				dxduserName: "",
				dxduserPwd: "",
				isChecked: false,
				timer: null,
				pageState: "",
			});


			// 登录
			const toLogin = async () => {
				if (data.isChecked) {
					proxy.$storage.set("dxduserName", data.dxduserName);
					proxy.$storage.set("dxduserPwd", data.dxduserPwd);
				}
				if (!data.dxduserName) {
					proxy.$message.error("请输入登录账号");
				}
				if (!data.dxduserPwd) {
					proxy.$message.error("请输入密码");
				}
				if (!$("#verifyX").val()) {
					proxy.$message.error("请滑动验证码");
					return false;
				}

				proxy.$storage.set("loginUserName", data.dxduserName);
				console.log($("#verifyX").val());
				const params = {
					userName: data.dxduserName,
					password: data.dxduserPwd,
				};

				const r = await proxy.$http.postFormData("/auth/logins/login", params);
				if (r.respCode === "0000") {
					proxy.$message.success(r.respMsg);
					loginSuccess(r);
				} else {
					proxy.$message.error(r.respMsg);
					dragInIt();
				}
				console.log(r);
			};
			const dragInIt = async () => {
				$("#drag_text").html("加载中");
				const r = await proxy.$http.get("/auth/imageValidate/imageShow", {});
				if (r) {
					$(".bottomImg").attr("src", r.checkImg);
					$(".slideImg").attr("src", r.checkImgMin);
					$(".slideImg").css("top", r.y + "px");
					$("#drag_text").html("向右滑动验证");
					$(".drag_bg").removeClass("drag_no_bg");
					$(".drag_text").removeClass("drag_no_text");
					$(".handler").addClass("handler_bg").removeClass("handler_Nook_bg");
					$(".handler").css({
						left: 0
					});
					$(".slideImg").css({
						left: 0
					});
					$(".drag_bg").css({
						width: 0
					});
					$(".handler_bg").html("");
					$("#drag").drag();
					$("#drag").removeClass("yanzhengOk");
					$("#verifyX").val("");
				}
			};
			// 记住密码
			const changeChecked = (isChecked) => {
				if (isChecked) {
					return;
				}
				if (!isChecked) {
					//删除本地账号密码
					if (proxy.$storage.get("dxduserName")) {
						proxy.$storage.remove("dxduserName");
					}
					if (proxy.$storage.get("dxduserPwd")) {
						proxy.$storage.remove("dxduserPwd");
					}
				}
			};
			// 监听用户是否点击授权登录
			const handleMessage = async () => {
				let params = {
					key: data.pageState,
				};
				const r = await proxy.$http.get('/auth/weChat/read"', params);
				if (r.respCode === "0000") {
					clearInterval(data.timer);
					autoLogin(r);
				}
			};
			const autoLogin = async (userId) => {
				let params = {
					userId: userId,
					type: "PC",
				};
				const r = await proxy.$http.get("/auth/weChat/quickLogin", params);
				if (r.respCode === "0000") {
					loginSuccess(r);
				}
			};

			const loginSuccess = (data) => {
				proxy.$store.commit("handleLogin", true);
				console.log(data);
				setToken(data.token); //设置token
				// proxy.$store.commit("setUserInfo", data.userInfo);
				proxy.$store.commit("isLogin", true); //登录验证 全局拦截标识
				proxy.$store.commit("handleMenuList", data.PcMenuDOList); // PC菜单信息
				proxy.$store.commit("isShowEditPasswordJD", data.pwdType); // 初始密码是否为123456 提醒修改密码
				//sessionStorage.setItem('perms',JSON.stringify(data.menuPerms));
				proxy.$storage.set("perms", data.menuPerms); //登录者权限
				proxy.$storage.set("userId", data.userId); //登录者ID
				proxy.$storage.set("userHeadImg", data.userHeadImg); //登录者头像
				router.push({
					name: "adminIndex",
				});
			};
			
			const upLoad = () => {
			    window.open("http://www.dxdcar.cn/download", "_blank");
			};
			
			onMounted(() => {
				if (proxy.$storage.get("dxduserName")) {
					data.dxduserName = proxy.$storage.get("dxduserName");
					data.isChecked = true;
				}
				if (proxy.$storage.get("dxduserPwd")) {
					data.dxduserPwd = proxy.$storage.get("dxduserPwd");
				}
			});
			return {
				...toRefs(data),
				toLogin,
				changeChecked,
				dragInIt,
				handleMessage,
				autoLogin,
				loginSuccess,
				upLoad
			};
		},
	});
</script>
<style scoped>
	.login_warp {
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
	}

	.login_warp>img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 1;
	}

	.login_mask {
		position: absolute;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.7);
		left: 0;
		top: 0;
		z-index: 2;
	}

	.login {
		width: 100%;
		height: 100%;
		position: relative;
		z-index: 3;
	}

	.login .logo_warp {
		width: 100%;
		height: 140px;
	}

	.logo_warp .logo {
		width: 200px;
		height: 100px;
	}

	.logo img {
		width: 100%;
		height: 100%;
		display: block;
		object-fit: cover;
	}

	.login_form_wrap {
		width: 100%;
	}

	.login_from_warp {
		width: 590px;
		height: 480px;
		position: relative;
	}

	.login_from_warp>img {
		position: absolute;
		left: 0;
		top: 0;
		z-index: 1;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.login_from {
		width: 580px;
		height: 430px;
		position: absolute;
		left: 5px;
		top: 40px;
		z-index: 2;
	}

	.login_type_warp {
		width: 100%;
		height: 50px;
	}

	.login_type_warp img {
		width: auto;
		height: 36px;
	}

	.login_input_warp {
		width: 500px;
		height: 60px;
		background: #fcfcfc;
		border-radius: 4px;
		margin-left: 40px;
		margin-bottom: 25px;
	}

	.login_input_warp img {
		width: 24px;
		height: 24px;
		margin-left: 18px;
		margin-right: 18px;
	}

	.login_input_line {
		width: 2px;
		height: 21px;
		background: #bfbfbf;
	}

	.login_from_bottom {
		width: 500px;
		margin-left: 40px;
	}

	.qr_box_warp {
		width: 500px;
		height: 350px;
		margin-left: 40px;
	}

	.qr_box {
		width: 400px;
		height: 320px;
		border-radius: 5px;
		background: #fff;
	}

	input {
		width: 100%;
		height: 100%;
		background: none;
		border: none;
		outline: none;
	}

	.inner {
		width: 100%;
		margin: 0 auto;
	}

	.downWrap {
		position: absolute;
		left: 0%;
		margin-left: 0px;
		margin-top: 130px;
	}

	.downBox {
		width: 230px;
		height: 290px;
		background: rgba(0, 0, 0, 0.1);
		border-radius: 30px;
		margin-left: 80%;
		padding-top: 50px;
	}

	.downBoxLeft {
		width: 150px;
		height: 150px;
		border: 1px solid #219346;
		border-radius: 12px;
		margin-right: 0px;
		line-height: 50px;
		color: #219346;
		font-size: 16px;
	}

	.erweima {
		width: 100px;
		height: 100px;
		margin: 0 auto;
		margin-top: 10px;
		display: block;
	}

	.downItem {
		height: 58px;
		font-size: 20px;
		color: #219346;
		border: 1px solid #219346;
		padding: 0 25px;
		border-radius: 58px;
		margin-right: 0px;
		cursor: pointer;
	}

	.downItem img {
		width: 35px;
		height: 39px;
		display: block;
		margin-right: 20px;
	}

	.downItem.ac {
		background-color: #219346;
		color: #fff;
	}
</style>